__turbopack_context__.v({
  "container": "PreOrderShoppingCart-module-scss-module__Eguvoq__container",
  "preOrderHostInfoButton": "PreOrderShoppingCart-module-scss-module__Eguvoq__preOrderHostInfoButton",
});
